import React from 'react';
import tinycolor2 from 'tinycolor2';
import styles from './FilterSelectionValue.module.scss';

/**
 * Renders a filter selection value component with the given props.
 *
 * @param {Object} props - The props object containing the following properties:
 *   - children: The content to be rendered inside the component.
 *   - color: The color of the component.
 * @return {JSX.Element} The rendered filter selection value component.
 */
function FilterSelectionValue(props) {
    const {children, color} = props;

    return (
        <div
            className={styles.FilterSelectionValue}
            style={{
                borderColor: tinycolor2(color).darken().toString(),
                backgroundColor: color,
            }}>
            {children}
        </div>
    );
}

export default FilterSelectionValue;
